import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["email", "select", "submit"];

  connect() {
    this.sync();
  }

  sync() {
    if (!this.hasEmailTarget || !this.hasSelectTarget || !this.hasSubmitTarget) return;

    const hasEmail = this.emailTarget.value.trim() !== "";
    const hasPublisher = this.selectTarget.value.trim() !== "";
    const shouldDisableSubmit = !(hasEmail && hasPublisher);

    this.submitTarget.disabled = shouldDisableSubmit;
    this.submitTarget.toggleAttribute("disabled", shouldDisableSubmit);
  }
}
